import Page from 'components/modules/public/pages/EmployerArticlesList';
export default Page;